import { NotificationMessages } from '../types';

export const notificationEN: NotificationMessages = {
    'app.notification.title': 'Notification Center',
    "app.notification.generate_file": "We are generating your file. Once it's ready, you will receive a notification to download it.",
    'app.notification.download_program': 'Download Program Details',
}
